import AppModalContainer from '@nxsys/components/AppModalContainer';
import AppTableContainer from '@nxsys/components/AppTableContainer';
import { useGetImportTimesheetById } from '@nxsys/hooks/api/import';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { ColumnsType } from 'antd/es/table';
import React, { useEffect, useMemo } from 'react';
import { IMPORT_COLUMNS_WIDTH } from '../constants';
import UploadedFileInformation from './UploadedFileInformation';

type ViewImportedTimesheetFileProps = {
  isOpen: boolean;
  toggle: () => void;
  id?: string;
};

const ViewImportedTimesheetFile: React.FC<ViewImportedTimesheetFileProps> = ({
  isOpen,
  toggle,
  id,
}) => {
  const { messages } = useTypedIntl();
  const {
    run: getImportTimesheetById,
    loading: getImportTimesheetByIdLoading,
    value: getImportTimesheetByIdValue,
  } = useGetImportTimesheetById();

  useEffect(() => {
    if (id) getImportTimesheetById(id);
  }, [id]);

  const {
    data = [],
    fileName,
    fileSize,
    totalRecords = 0,
    headersImportFile,
  } = getImportTimesheetByIdValue?.data || {};

  const columns: ColumnsType<any> = useMemo(() => {
    return (
      headersImportFile?.map((columnHeader, index) => ({
        key: `${columnHeader}_${index}`,
        title: <div className="truncate">{columnHeader}</div>,
        dataIndex: index,
        width:
          IMPORT_COLUMNS_WIDTH?.[
            columnHeader as keyof typeof IMPORT_COLUMNS_WIDTH
          ] ?? 200,
      })) ?? []
    );
  }, [headersImportFile, messages]);

  const dataTable = data.length > 1 ? data?.slice(1) : [];

  return (
    <AppModalContainer
      isOpen={isOpen}
      toggle={toggle}
      title={messages['bulkUpdate.modal.fileInformation']}
      width="90%"
    >
      <UploadedFileInformation
        fileName={fileName}
        fileSize={fileSize}
        totalRecords={totalRecords}
        hideFileSize
      />

      <AppTableContainer
        data={dataTable}
        loading={getImportTimesheetByIdLoading}
        page={0}
        total={totalRecords}
        pageSize={totalRecords}
        columns={columns}
        scroll={{ x: 1000, y: 500 }}
        {...(totalRecords > 1000 ? { virtual: true } : {})}
      />
    </AppModalContainer>
  );
};

export default ViewImportedTimesheetFile;
